module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcAgMAAAAPYzcHAAAADFBMVEUAAAAAAAAAAAAAAAA16TeWAAAAA3RSTlMASePizoNQAAAAMklEQVQI12NgIADY/oPABAZuMP0ATsPEidAPVsQN0oREsxGjGWb/BAaIvQ8QNBtx1gMAJ2Y029kegBwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/zdq-1@2x.png
// module id = p7gf
// module chunks = 96